import { FieldValues } from 'react-hook-form';

import {
  FormAwareTypeaheadMultiSelectInput,
  FormAwareTypeaheadMultiSelectInputProps,
} from '@/components/form/formAwareInputs/FormAwareTypeaheadMultiSelectInput';

import { useTeamMembersTypeahead } from './hooks/useTeamMembersTypeahead';

export type TeamMembersTypeaheadProps<FormShape extends FieldValues> = Omit<
  FormAwareTypeaheadMultiSelectInputProps<FormShape>,
  'options' | 'inputValue' | 'onInputChange'
>;

export function TeamMembersTypeahead<FormShape extends FieldValues>(
  props: TeamMembersTypeaheadProps<FormShape>
) {
  const { typeaheadProps } = useTeamMembersTypeahead<FormShape>(
    props.fieldName
  );

  return (
    <FormAwareTypeaheadMultiSelectInput<FormShape>
      {...typeaheadProps} // supplied by useAsyncTypeaheadProps
      {...props} // label, fieldName, disabled, etc.
      placeholder="Select member(s)"
    />
  );
}
